import { render } from "./SchedulePatientOverlay.vue?vue&type=template&id=6d72b8e3&scoped=true&lang=pug"
import script from "./SchedulePatientOverlay.vue?vue&type=script&lang=js"
export * from "./SchedulePatientOverlay.vue?vue&type=script&lang=js"

import "./SchedulePatientOverlay.vue?vue&type=style&index=0&id=6d72b8e3&scoped=true&lang=scss"

import exportComponent from "/app/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6d72b8e3"]])

export default __exports__